interface VALIDATION_STATE {
  path: string
  message: string
  [key: string]: string
}

interface ERROR_STATE {
  inner: VALIDATION_STATE[]
}

export const compileErrors = (err: ERROR_STATE) =>
  err.inner.reduce(
    (innerAcc: VALIDATION_STATE, { message, path }: { path: string; message: string }) => {
      innerAcc[path] = message
      return innerAcc
    },
    {} as VALIDATION_STATE
  )
